import React, { useSyncExternalStore } from 'react';
import { isPageLoading, subscribePageLoading } from '../services/session';
import PageLoader from './PageLoader';

export default function PageContentLoading({ children }) {
  const loading = useSyncExternalStore(subscribePageLoading, isPageLoading);
  return <div className={`page-content-loading${loading ? ' is-loading' : ''}`} aria-busy={loading}>
    <div className="page-content-loaded" inert={loading ? true : undefined}>{children}</div>
    {loading && <PageLoader />}
  </div>;
}
